import styles from './StatsBanner.module.css';

export const StatsBanner = () => {

   const items = [
      { title: '1000+', content: 'Attendees' },
      { title: `200+`, content: 'Top Innovators' },
      { title: '$280B', content: 'Under management' },
      { title: `160+`, content: 'Featured Investors' },
      { title: '2500', content: '1 on 1 Meetings' },
   ]



   return (
      <div className={styles.statsBanner}>
         <header>
            <h1>
               WHERE INNOVATION MEETS CAPITAL<span>™</span>
            </h1>
         </header>
         <main>
            {items.map((item, index) => {
               return (
                  <div
                     key={index}
                     className={styles.statsItem}
                  >
                     <div className={styles.imgTxt}>
                        <h3>{item.title}</h3>
                        <h6>{item.content}</h6>
                     </div>
                     <span>/</span>
                  </div>
               );
            })}
         </main>
      </div>
   );
}
